// angular
//     .module("HeroPRO")
//     .controller("POSignController", POSignController);

import angular from 'angular';
import './posign.scss';


/* @ngInject */
export default function POSignController(POSignFactory, $stateParams, $state, $analytics, Timestamp, $window, FRInformationFactory, ModalService) {
    const vm = this;
    vm.appInfo = {};
    vm.POs = [];
    vm.loadingPOs = true;

    /*= ========================================
    =            Private Functions            =
    ========================================= */

    FRInformationFactory.getFundingRequestInformationPromise().then(() => {
        vm.appInfo = FRInformationFactory.getAppInfo();
    });

    function determineEDocStatus(_POs) {
        const POs = angular.copy(_POs);

        // (ajt - 4/8/2016) Added null check
        if (POs) {
            POs.map((po) => {
                const stat = po.Owner.EDocumentRecipientStatus;

                po.signed = stat === 3 || stat === 5;
                po.sent = stat === 100;
                po.emailSending = false;
                return po;
            });
        }
        return POs;
    }

    POSignFactory.getPOInfo($stateParams.appId)
        .then((data) => {
            const poSignLoadTime = (new Date().getTime() - Timestamp.getTimestamp('stateChangeTimestamp'));
            $analytics.eventTrack('Module Initialize', { category: 'Module:POSign', value: poSignLoadTime });
            vm.POs = determineEDocStatus(data.data.PropertyOwnerData);
            vm.loadingPOs = false;
        });

    /* -----  End of Private Functions  ------*/


    /*= =======================================
    =            Public Functions            =
    ======================================== */

    vm.displayPOSign = function displayPOSign() {
        if (vm.loadingPOs === false) {
            ModalService.launchLgModal({
                templateUrl: 'app/appDetail/walkthrough/startWork/PO-Sign/PO-Modal.html',
                windowClass: 'po-sign-modal',
                controller: 'POSignModalController',
                controllerAs: 'POSignModal',
                resolve: {
                    data() {
                        return {
                            POs: vm.POs,
                            AppInfo: vm.appInfo,
                        };
                    },
                },
            });

            if (vm.POs && vm.POs.length > 0) { // Added to prevent trying to read 0 off undefined object.
                const emailSentToPO1 = (vm.checkIfEmailSent(vm.POs[0]) === true) ? 'DocsSent' : 'SendDocs';
                $analytics.eventTrack('Get Signatures Modal Open', { category: 'Walkthrough', label: `Start Work ${emailSentToPO1}` });
            }
        }
    };

    vm.checkIfEmailSent = function checkIfEmailSent(po) {
        return po.Owner.EDocumentRecipientStatusDate &&
                po.Owner.EDocumentRecipientStatusDate !== null &&
                po.Owner.EDocumentRecipientStatusDate !== '' &&
                po.Owner.EDocumentRecipientStatusDate !== 'undefined' &&
                po.Owner.EDocumentRecipientStatus === 100;
    };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/PO-Sign/POSignController.js